import { render, staticRenderFns } from "./ChatSenderConfigView.vue?vue&type=template&id=743d48fa"
import script from "./ChatSenderConfigView.vue?vue&type=script&lang=js"
export * from "./ChatSenderConfigView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports